var map = {
	"./2024-10/Product.vue": [
		603716,
		3716
	],
	"./2024-11/Product.vue": [
		169518,
		69518
	],
	"./2024-12/Product.vue": [
		840094,
		40094
	],
	"./2025-01/Product.vue": [
		95412,
		95412
	],
	"./2025-03/Product.vue": [
		224547,
		24547
	],
	"./2025-04/Product.vue": [
		784583,
		84583
	],
	"./2025-05/Product.vue": [
		606804,
		6804
	],
	"./2025-06/Product.vue": [
		786773,
		86773
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 532776;
module.exports = webpackAsyncContext;